export function createSearchQuery(id) {
  return {
    query: {
      bool: {
        must: [{ match: { id } }],
      },
    },
    _source: ["content.body"],
  };
}

export const getContentBody = (res) => res?.hits.hits?.[0]?._source?.content?.body;
